module.exports = __webpack_public_path__ + "img/logo-1.2e9f4d13.svg";